import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Layout, Modal, Card, Form, Input, Row, Col, Button } from "antd";

const Login = () => {
  const navigate = useNavigate();

  const [formSubmitted, setFormSubmitted] = useState(false);

  const [form] = Form.useForm();

  const onLoginFormFinish = async (values) => {
    try {
      setFormSubmitted(true);

      const { data, status } = await axios.post(`/api/auth/login`, values);

      setFormSubmitted(false);

      if (status === 200) {
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.log(`LogIn request failed: ${error}`);
      Modal.error({
        title: "Oops!",
        content: "Something went wrong, please try again.",
        centered: true,
        maskClosable: true,
        okText: "Try again"
      });
      setFormSubmitted(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout.Content
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Card
          title="ADMIN LOGIN"
          bordered
          style={{
            width: "100%",
            maxWidth: "420px"
          }}
        >
          <Form
            form={form}
            name="applications_advanced_search"
            onFinish={onLoginFormFinish}
          >
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  name="username"
                  rules={[
                    { required: true, message: "Please input your email!" }
                  ]}
                >
                  <Input placeholder="Email" size="large" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" }
                  ]}
                >
                  <Input.Password placeholder="Password" size="large" />
                </Form.Item>
              </Col>
              <Col span={12} offset={6}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={formSubmitted}
                  ghost
                  size="large"
                >
                  LOG IN
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Layout.Content>
    </Layout>
  );
};

export default Login;
